


























import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import Axios, { AxiosError, AxiosResponse } from 'axios';
import { AddressMarker, MarkerResult } from './interfaces/markers';
import { AddressResult, Address } from './interfaces/addresses';
import Map from './components/Map.vue';
import AddressList from './components/AddressList.vue';
import Pager from './components/Pager.vue';
import Search from './components/Search.vue';

@Component({
  components: {
    Map,
    AddressList,
    Pager,
    Search,
  },
})
export default class App extends Vue {
  @Prop({ default: '' })
  readonly markersUrl!: string;

  @Prop({ default: '' })
  readonly listUrl!: string;

  @Prop({ default: '' })
  readonly searchUrl!: string;

  @Prop({ default: '' })
  readonly apiKey!: string;

  @Prop({ default: [] })
  readonly categories!: {uid: number, name: string}[];

  markers: MarkerResult[] = [];

  addresses: Address[] = [];

  currentPage: number = 1;

  totalPages: number = 1;

  isLoading = false;

  coordinates: null | {lat: number, lng: number} = null;

  mounted() {
    this.getMarkers();
    this.getAddresses();
  }

  async getMarkers() {
    try {
      const result: AxiosResponse<MarkerResult[]> = await Axios.get(this.markersUrl);
      result.data.forEach((marker) => {
        this.markers.push(marker);
      });
    }
    catch (error) {
      console.log(error);
    }
  }

  async getAddresses() {
    try {
      const result: AxiosResponse<AddressResult> = await Axios.get(this.listUrl);
      this.addresses = result.data.addresses;
      this.currentPage = result.data.page;
      this.totalPages = result.data.totalPages;
    }
    catch (error) {
      console.log(error);
    }
  }

  onPageClicked(number: number) {
    this.currentPage = number;
    this.$el.scrollIntoView();
  }

  onSearchResult(searchResult: any) {
    this.currentPage = searchResult.currentPage;
    this.totalPages = searchResult.totalPages;
    if (searchResult.markers) {
      this.markers = searchResult.markers.filter((marker: any) => {
        return marker.latitude && marker.longitude;
      });
    }
    if (searchResult.coordinates) {
        this.coordinates = searchResult.coordinates;
      } else {
        this.coordinates = null;
      }
    
    this.addresses = searchResult.addresses;
  }
}
